module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon10.7d919ce2.png";